interface ItemProps {
  imgSrc: string;
  title: string;
  text: string;
}

const BRING_WHAT_LIST: ItemProps[] = [
  {
    imgSrc: 'https://static.fuxi.netease.com/yaotai/portal/index/lfm7c4h8_759913.png',
    title: '突破时空限制',
    text: '创新元宇宙活动形式',
  },
  {
    imgSrc: 'https://static.fuxi.netease.com/yaotai/portal/index/lfm7c4h6_759913.png',
    title: '助力降本增效',
    text: '形成可复用商业资产',
  },
  {
    imgSrc: 'https://static.fuxi.netease.com/yaotai/portal/index/lfm7c4h7_759913.png',
    title: '制造长效话题',
    text: '打造永不落幕的活动',
  },
  {
    imgSrc: 'https://static.fuxi.netease.com/yaotai/portal/index/lf108iu8_044896.png',
    title: '实现商业转化',
    text: '搭建企业私域元宇宙',
  },
];

const PC_SWIPE_LIST = [
  {
    speed: 40,
    list: [
      'https://static.fuxi.netease.com/yaotai/portal/index/lgd4irc9_617368.png',
      'https://static.fuxi.netease.com/yaotai/portal/index/lgd4ircc_617368.png',
      'https://static.fuxi.netease.com/yaotai/portal/index/lgd4irc6_617368.png',
      'https://static.fuxi.netease.com/yaotai/portal/index/lgd4irc3_617368.png',
      'https://static.fuxi.netease.com/yaotai/portal/index/lgd4irbz_617367.png',
      'https://static.fuxi.netease.com/yaotai/portal/index/lgd4irbv_617366.png',
      'https://static.fuxi.netease.com/yaotai/portal/index/lgd4irbq_617366.png',
      'https://static.fuxi.netease.com/yaotai/portal/index/lgd4irce_617368.png',
      'https://static.fuxi.netease.com/yaotai/portal/index/lgd4irc0_617367.png',
      'https://static.fuxi.netease.com/yaotai/portal/index/lgd4ircd_617368.png',
      'https://static.fuxi.netease.com/yaotai/portal/index/lgd4irc7_617368.png',
      'https://static.fuxi.netease.com/yaotai/portal/index/lgd4irc2_617367.png',
      'https://static.fuxi.netease.com/yaotai/portal/index/lgd4irca_617368.png',
      'https://static.fuxi.netease.com/yaotai/portal/index/lgd4irc8_617368.png',
    ],
  },
  {
    speed: 50,
    list: [
      'https://static.fuxi.netease.com/yaotai/portal/index/lgd4irc1_617367.png',
      'https://static.fuxi.netease.com/yaotai/portal/index/lgd4irbs_617366.png',
      'https://static.fuxi.netease.com/yaotai/portal/index/lgd4irbu_617366.png',
      'https://static.fuxi.netease.com/yaotai/portal/index/lgd4irc5_617368.png',
      'https://static.fuxi.netease.com/yaotai/portal/index/lgd4irbx_617366.png',
      'https://static.fuxi.netease.com/yaotai/portal/index/lgd4ircb_617368.png',
      'https://static.fuxi.netease.com/yaotai/portal/index/lgd4irby_617367.png',
      'https://static.fuxi.netease.com/yaotai/portal/index/lgd4irbt_617366.png',
      'https://static.fuxi.netease.com/yaotai/portal/index/lgd4irbr_617366.png',
      'https://static.fuxi.netease.com/yaotai/portal/index/lgd4irbw_617366.png',
      'https://static.fuxi.netease.com/yaotai/portal/index/lgd4irc4_617368.png',
    ],
  },
];

const CASE_LIST = [
  {
    poster: 'https://static.fuxi.netease.com/yaotai/portal/index/lfkvtoab_957166.png',
    title: '中央广播电视总台2023网络春晚元宇宙会场',
    tags: ['大型晚会', '活动元宇宙'],
    desc: '30天搭建3000万平“赛博国风”元宇宙会场，为央视网成功打造了网络春晚首个元宇宙会场，与上万网民在虚拟元宇宙会场沉浸式过小年。',
    liList: [
      '活动总触达人数<span>10亿</span>人次+，媒体累计曝光量超<span>6000W</span>',
      '引发了主流媒体对年轻人在元宇宙中过大年等社会议题的热议',
    ],
  },
  {
    poster: 'https://static.fuxi.netease.com/yaotai/portal/index/lfkvtoac_957167.png',
    title: '2022TEDx外滩女性大会',
    tags: ['大型演讲', '活动元宇宙'],
    desc: '通过复刻主舞台真实场景、提供个性化虚拟形象定制和多种互动功能等方式，助力TEDx外滩首场元宇宙线上活动成功举办。',
    liList: ['助力TEDx外滩实现办会方式和形式的全新突破', '制造元宇宙活动营销话题，引发各类媒体自主报道'],
  },
  {
    poster: 'https://static.fuxi.netease.com/yaotai/portal/index/lfkvtoad_957167.png',
    title: '河南文旅数字世界“元豫宙”',
    tags: ['数字文旅', '私域元宇宙'],
    desc: '携手河南省文化和旅游厅举办元宇宙创造者大赛，推出三维虚拟空间“元豫宙”，为河南文旅元宇宙的实践探索拉开了序幕。',
    liList: [
      '一个月内吸引近<span>60家</span>公司和团队参赛，征集作品超出既定目标一倍',
      '通过数字空间重现河南丰富文旅资源，推动河南文旅数字产业创新建设',
    ],
  },
  {
    poster: 'https://static.fuxi.netease.com/yaotai/portal/index/lfkvtoae_957167.png',
    title: '2022“生态守护映像”沉浸式公益生态摄影展',
    tags: ['艺术展厅', '展览元宇宙'],
    desc: '携手青海省玉树藏族自治州称多县政协举办2022“生态守护映像”沉浸式公益生态摄影展，一比一还原线下摄影展，革新传统艺术展览',
    liList: [
      '打造国内首个沉浸式公益生态摄影展，被多平台收录为经典案例',
      '引发党央媒体、科技媒体、元宇宙媒体广泛关注和报道，曝光量过千万',
    ],
  },
  {
    poster: 'https://static.fuxi.netease.com/yaotai/portal/index/lfkvtoa7_957166.png',
    title: '网易云音乐LOOK直播“云蹦迪”活动',
    tags: ['社交娱乐', '活动元宇宙'],
    desc: '联手网易云音乐LOOK直播推出“蹦迪选手请就位”云蹦迪活动，创新多人蹦迪比拼等互动玩法，打造前所未有的“元宇宙”云蹦迪体验。',
    liList: [
      '线上线下联动，打造多对多互动社交模型，丰富多元直播形式玩法',
      '亮相2022世界人工智能大会“元宇宙”特色展区，获得数<span>百万直播</span>观看量',
    ],
  },
  {
    poster: 'https://static.fuxi.netease.com/yaotai/portal/index/lfkvtoa8_957166.png',
    title: '第二十八届国际低温工程会议暨国际低温工程材料会议',
    tags: ['学术会议', '顶会元宇宙'],
    desc: '助力浙江大学举办第二十八届国际低温工程会议暨国际低温工程材料会议，众多国际重磅专家在虚拟世界中畅聊前沿学术知识。',
    liList: [
      '为低温领域最大规模、最具影响力的系列国际会议创新呈现形式',
      '兼具真实感、沉浸感的线上会议场景获得众多海外专家学者一致好评',
    ],
  },
  {
    poster: 'https://static.fuxi.netease.com/yaotai/portal/index/lfkvtoa9_957166.png',
    title: '“浙里烟火”·杭州亚运 元宇宙烟花大会',
    tags: ['烟花大会', '活动元宇宙'],
    desc: '由第19届杭州亚运组委会、浙江省文化和旅游厅指导的“浙里烟火”·杭州亚运 元宇宙烟花大会顺利举行，网易瑶台提供技术服务支持。 ',
    liList: [
      '传统节日与现代科技的创新结合，打造了一场别开生面的元宇宙烟花大会',
      '借助新技术、打破次元壁传递亚运文化，全方位体验亚运氛围',
    ],
  },
  {
    poster: 'https://static.fuxi.netease.com/yaotai/portal/index/lfkvtoaa_957166.png',
    title: '佳沃蓝莓元宇宙养眼乐园',
    tags: ['品牌营销', '新零售元宇宙'],
    desc: '联手佳沃蓝莓打造全球首个水果品牌元宇宙“佳沃蓝莓元宇宙养眼乐园”，上线即引爆社交媒体，超千万用户共享线上养眼狂欢。',
    liList: [
      '吸引大批Z世代消费者注册参与，品牌相关指数飙升<span>800%</span>',
      '以颠覆性创新，助力佳沃蓝莓引领果业品牌“虚拟共生营销新时代”',
    ],
  },
];

const COUNT_ARR = [
  {
    start: 50,
    count: 100,
    text: '覆盖国家及地区',
    unit: '+',
  },
  {
    start: 10,
    count: 28,
    text: '覆盖行业类型',
    unit: '+',
  },
  {
    start: 100,
    count: 20000,
    text: '举办活动场次',
    unit: '+',
  },
  {
    start: 50,
    count: 500,
    text: '累计参会人数',
    unit: '万+',
  },
];
const AUTH_LIST = [
  {
    imgSrc: 'https://static.fuxi.netease.com/yaotai/portal/index/lf9b9kni_299082.png',
    text: 'CSA STAR Certificati­o­n 2013体系认证',
  },
  {
    imgSrc: 'https://static.fuxi.netease.com/yaotai/portal/index/lf9b9kne_299081.png',
    text: '网络安全等级保护',
  },
  {
    imgSrc: 'https://static.fuxi.netease.com/yaotai/portal/index/lf9b9knf_299081.png',
    text: 'ISO 27001 信息安全管理体系认证',
  },
  {
    imgSrc: 'https://static.fuxi.netease.com/yaotai/portal/index/lf9b9kng_299081.png',
    text: 'ISO 20000 信息技术服务管理体系认证',
  },
  {
    imgSrc: 'https://static.fuxi.netease.com/yaotai/portal/index/lf9b9knh_299081.png',
    text: 'ISO 9001 质量管理体系认证',
  },
];
export { BRING_WHAT_LIST, PC_SWIPE_LIST, CASE_LIST, COUNT_ARR, AUTH_LIST };
export type { ItemProps };
